import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _set from 'lodash/set';

import { multiCaseGet, objectToSnakeCase } from 'libs/format';

import { getGoogleLocationProviderSettings } from '../../services/provider-service';

export function getInitialSettings(providerServiceSettings, selectedLocationId) {
  const locationSettings = getGoogleLocationProviderSettings(providerServiceSettings);

  const locationSetting = locationSettings.find(
    (setting) => _get(setting, 'serviceData.fishermanLocationId') === selectedLocationId,
  );

  const initialSettings = multiCaseGet(
    locationSetting,
    'serviceData.settings.reviews.response',
    {},
  );

  return initialSettings;
}

export function getServiceDataPayload(setting, newResponseSettings) {
  const { ratings } = newResponseSettings;

  const newServiceData = _cloneDeep(multiCaseGet(setting, 'serviceData', {}));
  _set(newServiceData, 'settings.reviews.response.ratings', ratings);

  return objectToSnakeCase({ serviceData: newServiceData });
}
